import GridViewLayout from './GridViewLayout';
export default GridViewLayout;
